import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { appTypes } from '../../../common/constants';
import { config } from '../config';
import { convertLanguageJsonToObject } from './resources';
import types from './types.json';

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(types);

(() => {
  if (config.appType !== appTypes.merchants) return;
  i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      lng: window.localStorage.language || config.defaultLanguage, // it will use the stored user language from db
      fallbackLng: false,
      debug: false,
      backend: {
        loadPath: `${config.merchantsApiUrl}/static/resources/{{lng}}`,
        crossDomain: true,

        //reloadInterval: 10000,
      },
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });
})();

export default i18n;
